import { arrangeArrayOfStringAlphabetically } from "./helpers";
import {
  BUSINESS_INSURANCE,
  BUSINESS_DEPOSIT,
  BUSINESS_CASH_MANAGEMENT_SOLUTION,
  BUSINESS_LOAN_SOLUTION,
  BUSINESS_FIXED_INCOME_PRODUCT,
  BUSINESS_INVESTMENT,
  BUSINESS_FOREX_SERVICE,
} from "routes/paths";
import { store_locations } from "./stores";

export const GENDER_OPTIONS = [
  {
    label: "Male",
    value: "Male",
  },
  {
    label: "Female",
    value: "Female",
  },
];

export const TAX_STATUS = [
  {
    label: "Single",
    value: "Single",
  },
  {
    label: "Married",
    value: "Married",
  },
  {
    label: "Divorced",
    value: "Divorced",
  },
  {
    label: "Widower",
    value: "widower",
  },
];

export const CITY_MUNICIPALITY_PROVINCES = [
  "Abra",
  "Agusan del Norte",
  "Agusan del Sur",
  "Aklan",
  "Albay",
  "Angeles City",
  "Antipolo City",
  "Antique",
  "Apayao",
  "Aurora",
  "Bacolod",
  "Bacolod City",
  "Baguio",
  "Baguio City",
  "Basilan",
  "Batanes",
  "Batangas",
  "Batangas City",
  "Benguet",
  "Biliran",
  "Bohol",
  "Bukidnon",
  "Bulacan",
  "Butuan City",
  "Cabanatuan",
  "Cabanatuan City",
  "Cagayan",
  "Cagayan De Oro",
  "Cagayan de Oro City",
  "Caloocan City",
  "Camarines Norte",
  "Camarines Sur",
  "Camiguin",
  "Capiz",
  "Catanduanes",
  "Cavite",
  "Cavite",
  "Cavite City",
  "Cebu",
  "Cebu City",
  "Compostella Valley",
  "Cotabato",
  "Davao",
  "Davao City",
  "Davao del Norte",
  "Davao del Sur",
  "Davao Oriental",
  "Eastern Samar",
  "General Santos City",
  "Guimaraz",
  "Ifugao",
  "Iligan City",
  "Ilocos Norte",
  "Ilocos Sur",
  "Iloilo",
  "Iloilo City",
  "Isabela",
  "Kalinga",
  "La Union",
  "Laguna",
  "Lanao del Norte",
  "Lanao del Sur",
  "Las Pinas City",
  "Leyte",
  "Lipa city",
  "Lucena",
  "Lucena City",
  "Maguindanao",
  "Makati City",
  "Malabon",
  "Malabon City",
  "Mandaluyong City",
  "Mandaue City",
  "Manila",
  "Marikina City",
  "Marinduque",
  "Masbate",
  "Misamis Occidental",
  "Misamis Oriental",
  "Mountain Province",
  "Muntinlupa City",
  "Naga",
  "Naga City",
  "Negros Occidental",
  "Negros Oriental",
  "Northern Samar",
  "Nueva Ecija",
  "Nueva Viscaya",
  "Occidental Mindoro",
  "Olongapo",
  "Olongapo City",
  "Oriental Mindoro",
  "Ozamiz City",
  "Palawan",
  "Pampanga",
  "Pangasinan",
  "Parañaque City",
  "Pasay City",
  "Pasig City",
  "Quezon",
  "Quezon City",
  "Quirino",
  "Rizal",
  "Romblon",
  "Samar",
  "San Juan",
  "San Pablo City",
  "Santiago City, Isabela",
  "Sarangani",
  "Siquijor",
  "Sorsogon",
  "South Cotabato",
  "Southern Leyte",
  "Sultan Kudarat",
  "Sulu",
  "Surigao del Norte",
  "Surigao del Sur",
  "Tacloban",
  "Tacloban City",
  "Tagaytay City",
  "Tagbilaran City",
  "Taguig",
  "Taguig City",
  "Tarlac",
  "Tawi-Tawi",
  "Urdaneta",
  "Valenzuela City",
  "Zambales",
  "Zamboanga",
  "Zamboanga City",
  "Zamboanga del Norte",
  "Zamboanga del Sur",
];

export const SOURCE_OF_FUNDS_OPTIONS = [
  "Business Income",
  "Salary Benefits",
  "Pension",
  "Dividends",
  "Interest on Savings/Investments/Trust Funds",
  "Retirement Pay",
  "Separation Pay",
  "Allowance from",
  "Remittance from",
  "Inheritance from",
  "Gifts/Donation from",
  "Lottery Winnings From",
];

export const NATURE_OF_BUSINESS_OPTIONS = [
  "Agriculture/Forestry/Fishing",
  "Mining/Quarrying",
  "Manufacturing",
  "Electricity/Gas/Steam/Air Conditioning Supply",
  "Water/Sewerage/Waste Management/Remediation",
  "Construction",
  "Wholesale and Retail Trade/Repair of Motor Vehicles",
  "Transportation and Storage",
  "Accommodation and Food Service",
  "Financial and Insurance",
  "Real Estate",
  "Professional/Scientific/Technical Services",
  "Administrative/Support Service",
  "Public Administrative and Defense/Compulsory Social Security",
  "Education",
  "Human Health/Social Work",
  "Arts/Entertainment/Recreation",
  "Other Service Activities",
  "Private Household",
  "Extra-Territorial Organization/Bodies",
];

export const TYPE_OF_BUSINESS_DROPDOWN = arrangeArrayOfStringAlphabetically(
  NATURE_OF_BUSINESS_OPTIONS.map((item) => ({ value: item, label: item })),
  "label"
);

export const JOB_TITLE_OPTIONS = [
  "Staff-Contractual",
  "Staff-Regular",
  "Junior Officer",
  "Senior Officer",
  "President",
  "Directore",
  "Owner",
  "Professional",
];

export const TEMP_OPTIONS = ["Option 1", "Option 2", "Option 3"];

export const EASYWAY_APPLICATION_PURPOSE_OPTIONS = TEMP_OPTIONS;

export const BENEFICIAL_OWNERSHIP_OPTIONS = TEMP_OPTIONS;

export const FATCA_OPTIONS = TEMP_OPTIONS;

export const POLITICAL_RELATIONS_OPTIONS = TEMP_OPTIONS;

export const ONLINE_GAMING_OPTIONS = TEMP_OPTIONS;

export const BOOKING_ENGINE = TEMP_OPTIONS;

export const GROSS_ANNAUL_INCOME_OPTIONS = TEMP_OPTIONS;

export const THIS_FIELD_IS_REQUIRED = "This field is required";

export const LOAN_SOURCE = [
  { label: "Dealer Gen", value: "Dealer Gen" },
  { label: "Direct Loan", value: "Direct Loan" },
];

export const PRODUCT_TYPE = [
  { label: "Auto", value: "Auto" },
  { label: "Light Comm Vehicle", value: "Light Comm Vehicle" },
  { label: "Asian Utility Vehicle", value: "Asian Utility Vehicle" },
];

export const LOAN_TYPE = [
  { label: "Brand New", value: "Brand New" },
  { label: "Used/Second Hand", value: "Used/Second Hand" },
];

export const LOAN_TERMS = [
  { label: 12, value: 12 },
  {
    label: 18,
    value: 18,
  },
  {
    label: 24,
    value: 24,
  },
  {
    label: 38,
    value: 38,
  },
  {
    label: 48,
    value: 48,
  },
  {
    label: 60,
    value: 60,
  },
];

export const LOAN_AMOUNT = [
  {
    label: "500,000 to 999,000",
    value: "500,000 to 999,000",
  },
  {
    label: "1,000,000 to 4,999,000",
    value: "1,000,000 to 4,999,000",
  },
  {
    label: "5,000,000 to 9,999,000",
    value: "5,000,000 to 9,999,000",
  },
  {
    label: "10,000,000 to 15,000,000",
    value: "10,000,000 to 15,000,000",
  },
];
export const EMPLOYMENT_TYPE = [
  {
    label: "Employee",
    value: "Employee",
  },
  {
    label: "Self-Employed",
    value: "Self-Employed",
  },
];

export const BUSINESS_ENTITY = [
  {
    label: "Corporation",
    value: "Corporation",
  },
  {
    label: "Sole Proprietorship",
    value: "Sole Proprietorship",
  },
  {
    label: "Partnership",
    value: "Partnership",
  },
];

export const CREDIT_FACILITY_APPLIED_FOR_OPTIONS = [
  {
    label: "Revolving Credit Facility",
    value: "Revolving Credit Facility",
  },
  {
    label: "Term Loan",
    value: "Term Loan",
  },
];

export const BUSINESS_LOAN_PURPOSE = [
  {
    label: "Working Capital",
    value: "Working Capital",
  },
  {
    label: "Business Expansion",
    value: "Business Expansion",
  },
  {
    label: "Property Acquisition (for Business)",
    value: "Property Acquisition",
  },
  {
    label: "Purchase of Machine/Equipment/Materials",
    value: "Purchase of Machine/Equipment/Materials",
  },
  // {
  //   label: "Construction (for business)",
  //   value: "Construction (for business)",
  // },
  {
    label: "Others",
    value: "Other",
  },
];

export const STORES = [
  "The Fort-Marajo Tower",
  "The Fort-F1 Center",
  "The Fort-Burgos Circle",
  "The Fort-Beaufort",
  "The Fort-PSE Tower",
  "The Fort-South of Market",
  "The Fort-Active Fun",
  "The Fort-BGC Corporate Center",
  "The Fort Seven Neo",
  "The Fort - Brilliance Center",
  "P.Ocampo Avenue",
  "Metropolitan Avenue",
  "Chino Roces-Bagtikan",
  "Pasong Tamo Extension",
  "Ayala Ave-SGV",
  "San Lorenzo-A. Arnaiz",
  "Perea",
  "Paseo-Philam Tower",
  "Paseo de Roxas-Legaspi",
  "Rada",
  "Benavidez",
  "Amorsolo-Queensway",
  "Ayala Ave-Rufino",
  "Chino Roces-La Fuerza",
  "Legaspi-Aguirre",
  "Gil Puyat-Metro House",
  "Valero",
  "Gil Puyat-Pacific Star",
  "Makati Ave.-Juno",
  "J.P. Rizal",
  "H.V. Dela Costa",
  "Jupiter-Paseo de Roxas",
  "Tordesillas",
  "Gil Puyat-Salcedo Vill.",
  "Leviste",
  "Ayala Ave.-Herrera",
  "Salcedo",
  "Chino Roces-Dela Rosa",
  "Legaspi-Rufino",
  "Ayala Ave. - Makati Sky Plaza",
  "Evangelista",
  "Paseo de Magallanes",
  "Gil Puyat-F.B. Harrison",
  "Pasay-D. Macapagal Blvd",
  "Pasay-Libertad",
  "Legaspi-Dela Rosa",
  "Gil Puyat-Dian",
  "Pasay-Oceanaire",
  "Gil Puyat - Washington",
  "Sto. Cristo",
  "T. Alonzo",
  "Binondo",
  "Divisoria",
  "Soler",
  "168 Mall",
  "City Place Square",
  "Masangkay",
  "Tomas Mapua-Lope de Vega",
  "999 Shopping Mall",
  "Elcano",
  "Ongpin",
  "Ylaya-Padre Rada",
  "Juan Luna-Binondo",
  "Juan Luna-Pritil",
  "Intramuros",
  "UN Avenue",
  "Paco",
  "Roxas Boulevard",
  "Taft-Nakpil",
  "Taft Avenue",
  "T.M. Kalaw",
  "Paz M. Guazon",
  "Sampaloc-J. Figueras",
  "Pedro Gil",
  "A.Mabini-R.Salas",
  "Baclaran",
  "Quiapo",
  "Escolta",
  "Loyola Heights-Katipunan",
  "Fairview",
  "Kalayaan-Matalino",
  "Don Antonio Heights",
  "Tandang Sora",
  "Xavierville",
  "UP Village",
  "Commonwealth",
  "Regalado",
  "Project 8-Shorthorn",
  "Congressional Ave.",
  "Visayas Avenue",
  "Lagro",
  "Novaliches-Gulod",
  "Baesa Town Center",
  "Novaliches-Talipapa",
  "G. Araneta Ave.",
  "Banawe-Sct. Alcaraz",
  "Del Monte-D. Tuazon",
  "Masambong",
  "Quezon Ave.-Banawe",
  "Banawe-Kaliraya",
  "Balintawak-A. Bonifacio",
  "North EDSA",
  "Del Monte",
  "Mayon",
  "Mayon-Dapitan",
  "Roosevelt-Sto. Niño",
  "E.Rod-Welcome Rotonda",
  "Edsa Howmart",
  "EDSA-Muñoz",
  "A. Bonifacio-Balingasa",
  "Roosevelt-Frisco",
  "Banawe-N. Roxas",
  "EDSA-Kalookan",
  "Valenzuela-Marulas",
  "Grace Park-8th Ave.",
  "Paso De Blas",
  "Malabon-Gov. Pascual",
  "Malabon-Potrero",
  "Navotas-North Bay",
  "Caloocan-A. Mabini",
  "Grace Park-7th Ave.",
  "Malabon-Rizal Avenue",
  "Grace Park-11th Ave.",
  "Valenzuela-Dalandanan",
  "Navotas-M. Naval",
  "General Luis-Kaybiga",
  "Grace Park-3rd Ave.",
  "Valenzuela-Gen. T. De Leon",
  "Jose Abad Santos-Tayuman",
  "Blumentritt-Rizal Ave.",
  "New Manila",
  "E. Rodriguez Ave.",
  "Tomas Morato",
  "Cubao-Araneta Center",
  "E. Rodriguez Ave.-Cubao",
  "Timog Ave.",
  "Aurora Blvd.-Anonas",
  "Kamuning",
  "Timog-Mother Ignacia",
  "Boni Serrano Ave.",
  "Kamias",
  "West Avenue",
  "Anonas",
  "Cubao-P. Tuazon",
  "Quezon Ave-Sct Santiago",
  "Quezon Ave-Dr. Garcia",
  "Quezon Ave-Sct Albano",
  "F. Ortigas Jr.",
  "Pasig-Shaw Blvd.",
  "Pasig-Caruncho",
  "Tektite",
  "San Miguel Ave.",
  "Ortigas-Emerald",
  "C. Raymundo Ave.",
  "Ortigas-Rockwell",
  "Pasig Boulevard",
  "Julia Vargas",
  "Ortigas-Garnet",
  "Silver City",
  "Pasig Rosario",
  "Pasig-Santolan",
  "Pateros",
  "Ortigas-ADB Avenue",
  "Ortigas - Orient Square",
  "Mandaluyong-Shaw Blvd.",
  "Annapolis",
  "Greenhills-West",
  "San Juan",
  "Pioneer",
  "Mandaluyong-Libertad",
  "Greenhills Shopping Center",
  "Wilson",
  "Greenhills-Connecticut",
  "Boni Avenue",
  "Greenhills-North",
  "Mandaluyong - Wack-Wack",
  "Kalentong",
  "Greenhills-Promenade",
  "Festival Mall Level 2",
  "Alabang-Westgate",
  "Festival Mall Level 1",
  "Alabang Madrigal",
  "Muntinlupa",
  "Alabang-Commerce Ave.",
  "Alabang Entrata",
  "Alabang Hills",
  "Las Piñas-Pamplona",
  "Las Piñas-BF Resort",
  "Las Piñas-Marcos Alvarez",
  "Las Piñas-Almanza",
  "Las Piñas-J.Aguilar Ave.",
  "Alabang - Frabelle",
  "Festival Mall – Expansion Wing",
  "BetterLiving-Doña Soledad",
  "President's Avenue",
  "West Service Road",
  "Better Living-Peru",
  "BF Homes-Aguirre",
  "Bicutan-East Service Rd",
  "Sucat-NAIA",
  "Sucat-Evacom",
  "Sucat-Kingsland",
  "Sucat-Kabihasnan",
  "MIA Road",
  "Marikina-Parang",
  "Marikina-Concepcion",
  "Montalban-Rizal",
  "Taytay-Manila East",
  "Marikina-Gil Fernando",
  "Taytay-Ortigas Ext.",
  "Antipolo-ML Quezon",
  "Antipolo-Marcos Hi-way",
  "Marikina-J.P. Rizal",
  "San Mateo",
  "Bagumbayan",
  "Eastwood City",
  "Acropolis",
  "Katipunan-St. Ignatius",
  "Imus",
  "Bacoor-Aguinaldo Hi-way",
  "Carmona",
  "General Trias",
  "Bacoor-Molino",
  "Cavite-Naic",
  "Cavite-Tanza",
  "Dasmariñas",
  "Cavite City",
  "Cavite-Trece Martires",
  "Cavite-Silang",
  "Kawit-Centennial",
  "Cavite - Rosario",
  "Tagaytay",
  "Lucena City",
  "Batangas City",
  "Lipa City",
  "Batangas-Bauan",
  "Mindoro-Calapan",
  "Batangas-Tanauan",
  "Batangas-Lemery",
  "Batangas-Rosario",
  "Batangas-Nasugbu",
  "Batangas-Sto. Tomas",
  "Batangas-Balayan",
  "Batangas City - Pallocan",
  "Candelaria",
  "Calamba",
  "Naga City",
  "San Pablo",
  "San Pedro",
  "Laguna-Cabuyao",
  "Legazpi City",
  "Laguna-Biñan",
  "Sorsogon City",
  "Sta. Rosa",
  "Tabaco City",
  "Calamba - National Road",
  "Laguna-Sta. Cruz",
  "San Fernando-Dolores",
  "Pampanga-Angeles City",
  "Tarlac-F. Tañedo",
  "Olongapo City",
  "Bataan-Balanga",
  "Pampanga-Apalit",
  "Angeles-Balibago",
  "San Fernando-Sindalan",
  "Bataan-Dinalupihan",
  "Pampanga-Guagua",
  "Tarlac-Paniqui",
  "Subic Bay",
  "San Fernando-JASA",
  "Zambales-Iba",
  "Bataan-Mariveles",
  "Tarlac - Concepcion",
  "Tarlac - McArthur Highway",
  "Pampanga-Clark",
  "Cabanatuan-Melencio",
  "Isabela-Santiago",
  "Baliuag",
  "Isabela-Cauayan",
  "Tuguegarao City",
  "Nueva Ecija-San Jose",
  "Nueva Vizcaya-Solano",
  "Bulacan-Plaridel",
  "Nueva Ecija-Gapan",
  "Isabela-Ilagan",
  "Nueva Ecija-Talavera",
  "Bulacan-San Jose Del Monte",
  "Cabanatuan-Maharlika",
  "Bulacan - Sta. Maria",
  "Meycauayan-Malhacan",
  "Bulacan-Balagtas",
  "Malolos",
  "Isabela - Roxas",
  "Dagupan-Perez",
  "Baguio-Rizal Monument",
  "Laoag City",
  "La Union-San Fernando",
  "Urdaneta City",
  "Pangasinan-San Carlos",
  "Baguio City-Session Rd.",
  "Ilocos Sur-Candon",
  "Pangasinan-Rosales",
  "Dagupan-A.B. Fernandez",
  "Benguet-La Trinidad",
  "Vigan",
  "Pangasinan-Lingayen",
  "La Union-Agoo",
  "Ilocos Norte-San Nicolas",
  "Pangasinan - Mangaldan",
  "Pangasinan-Alaminos",
  "Baguio - Legarda",
  "Cebu-Banilad",
  "Cebu-N. Escario",
  "Cebu-Grand Cenia",
  "Cebu-Magallanes",
  "Cebu-Mandaue Subangdaku",
  "Cebu-Colon",
  "Cebu-Freedom Park",
  "Cebu-M. Velez",
  "Cebu-A.S. Fortuna",
  "Cebu-Park Mall",
  "Cebu-Fuente Osmeña",
  "Cebu IT Park",
  "Cebu - Srp Il Corso",
  "Bacolod-Lacson",
  "Iloilo-Iznart",
  "Iloilo-Ledesma",
  "Bacolod-Mandalagan",
  "Bacolod-Hilado",
  "Iloilo-Jaro",
  "Boracay",
  "Kalibo",
  "Roxas City",
  "Bacolod-Araneta",
  "Antique-San Jose",
  "Iloilo-Molo",
  "Silay",
  "Bacolod - East",
  "Iloilo-Diversion",
  "Davao-Lanang",
  "Davao-Sta. Ana",
  "Davao-Matina",
  "Davao-Toril",
  "Davao-C.M. Recto",
  "Davao-Bajada",
  "Davao-J.P. Laurel",
  "Davao-Buhangin",
  "Davao-Agdao",
  "Davao-McArthur Matina",
  "Davao-Quirino",
  "Davao-Magsaysay",
  "Davao-Diversion Road",
  "Davao-Ma-a",
  "Butuan City",
  "Cagayan de Oro-Velez",
  "Iligan City",
  "Ozamiz City",
  "Zamboanga-NS Valderrosa",
  "Cagayan de Oro-Cogon",
  "Pagadian City",
  "Zamboanga-Canelar",
  "Surigao City",
  "Dipolog City",
  "Cagayan de Oro-Carmen",
  "Cagayan de Oro-Lapasan",
  "Butuan-P. Burgos",
  "Cagayan De Oro - Pueblo de Oro",
  "Cebu-Minglanilla",
  "Cebu-Talisay",
  "Cebu-Basak Pardo",
  "Cebu-Mandaue North Road",
  "Ormoc City",
  "Tacloban City-Marasbaras",
  "Tacloban-J. Romualdez",
  "Tagbilaran City",
  "Catbalogan City",
  "Palawan",
  "Dumaguete City",
  "Cebu Mactan",
  "Cebu-A.C. Cortes",
  "Koronadal City",
  "General Santos-Pioneer",
  "General Santos City-Calumpang",
  "General Santos-Santiago",
  "Cotabato City",
  "Kidapawan",
  "Bukidnon-Valencia",
  "Tacurong",
];

export const stores = arrangeArrayOfStringAlphabetically(
  store_locations.map((item) => ({
    value: item.store_name,
    label: item.store_name,
  })),
  "label"
);

const REASON_FOR_NO_TIN = [
  "Student",
  "Never been employed",
  "Non Resident",
  "Registration is still in process",
  "Business not registered",
];
export const investedProducts = [
  { value: "TBills", label: "TBills" },
  { value: "RTBs or FXTNs", label: "RTBs or FXTNs" },
  { value: "Corporate Bonds", label: "Corporate Bonds" },
  { value: "UITF Money Market Fund", label: "UITF Money Market Fund" },
  { value: "UITF Bond Funds", label: "UITF Bond Funds" },
  { value: "UITF Equity Funds", label: "UITF Equity Funds" },
];

export const investmentHistory = [
  {
    value: "Time Deposit",
    label: "Time Deposit",
  },
  {
    value: "Bonds",
    label: "Bonds",
  },
  {
    value: "Stocks",
    label: "Stocks",
  },
  {
    value: "UITF",
    label: "UITF",
  },
];

export const AMPM = [
  { value: "AM", label: "AM" },
  { value: "PM", label: "PM" },
];

export const YESNO = [
  { value: "YES", label: "yes" },
  { value: "NO", label: "no" },
];

export const CITIZEN_OR_RESIDENT = [
  {
    value: "Resident",
    label: "Resident",
  },
  {
    value: "Citizen",
    label: "Citizen",
  },
];

const EMPLOYMENT_STATUS = [
  "Employer",
  "Self-Employed",
  "Wage & Salary Worker Private",
  "Wage & Salary Worker-Government",
  "Wage & Salary Worker-Overseas Contract Worker",
  "Unpaid Family Worker",
  "Unemployed-Retiree",
  "Unemployed-Student",
  "Unemployed-Others",
];

export const getEmploymentStatusDropdownOptions = () => {
  return EMPLOYMENT_STATUS.map((item) => ({ label: item, value: item }));
};

export const getReasonForNoTin = () => {
  return REASON_FOR_NO_TIN.map((item) => ({ label: item, value: item }));
};

export const INQUIRE_ABOUT = [
  { value: "Deposits", label: "Deposits" },
  { value: "Collections", label: "Collections" },
  { value: "Disbursements", label: "Disbursements" },
  { value: "Payroll Management", label: "Payroll Management" },
  { value: "Government Payments", label: "Government Payments" },
  { value: "Business Loans", label: "Business Loans" },
  { value: "Auto Loans", label: "Auto Loans" },
  { value: "Forex Services", label: "Forex Services" },
  { value: "Investments and Trust", label: "Investments and Trust" },
  { value: "Insurance", label: "Insurance" },
  { value: "Others", label: "Others", disabled: true },
];

export const regions = [
  "Metro Manila",
  "Region 1",
  "Region 2",
  "Region 3",
  "Region 4-A",
  "Region 5",
  "Region 6",
  "Region 7",
  "Region 9",
  "Region 10",
  "Region 11",
  "Region 12",
  "Mimaropa",
  "NCR",
];

export const NATURE_OF_BUSINESS = [
  "Agriculture, forestry and fishing",
  "Mining and Quarrying",
  "Manufacturing",
  "Electricity, gas, steam and air-conditioning supply",
  "Water supply, sewerage, waste management and remediation activities",
  "Construction",
  "Wholesale and retail trade; repair of motor vehicles and motorcycles",
  "Transportation and Storage",
  "Accommodation and food service activities",
  "Information and Communication",
  "Financial and insurance activities",
  "Real estate activities",
  "Professional, scientific and technical services",
  "Administrative and support service activities",
  "Education",
  "Human health and social work activities",
  "Arts, entertainment and recreation",
  "Other service activities",
];

const AUTO_LOAN_TYPES = ["Brand New", "Second Hand"];
const AUTO_LOAN_TYPE_PURPOSE = ["Personal Use", "Business Use", "Public Use"];

export const AUTO_LOAN_TYPES_OPTIONS = AUTO_LOAN_TYPES.map((item) => ({
  label: item,
  value: item,
}));

export const AUTO_LOAN_PURPOSE_OPTIONS = AUTO_LOAN_TYPE_PURPOSE.map((item) => ({
  label: item,
  value: item,
}));
export const COLLATERAL_OFFERED_OPTIONS = [
  {
    value: "Real Estate Mortgage",
    label: "Real Estate Morgage",
  },
  {
    value: "EWB Deposit Hold-out",
    label: "EWB Deposit Hold-out",
  },
];

export const BUSINESS_LOAN_APPLICATION_NATURE_OF_BUSINESS_OPTIONS = [
  {
    value: "Trading",
    label: "Trading",
  },
  {
    value: "Manufacturing",
    label: "Manufacturing",
  },
  {
    value: "Merchandising",
    label: "Merchandising",
  },
  {
    value: "Services",
    label: "Services",
  },
  {
    value: "Others",
    label: "Others",
  },
];

export const EMAIL_BY_BUSINESS_SOLUTION = [
  {
    urlSolution: BUSINESS_DEPOSIT,
    emailSolution: "",
    titleSolution: "Deposit",
  },
  {
    urlSolution: BUSINESS_CASH_MANAGEMENT_SOLUTION,
    emailSolution: "#cmdsales@eastwestbanker.com",
    titleSolution: "Cash Management",
  },
  {
    urlSolution: BUSINESS_LOAN_SOLUTION,
    emailSolution: "#EEL-EmergingEnterprisesLending@eastwestbanker.com",
    titleSolution: "Business Loan Solution",
  },
  {
    urlSolution: BUSINESS_FIXED_INCOME_PRODUCT,
    emailSolution: "SEDEX-RetailSalesDivision@eastwestbanker.com",
    titleSolution: "Fixed Income Product",
  },
  {
    urlSolution: BUSINESS_INVESTMENT,
    emailSolution: "SEDEX-RetailSalesDivision@eastwestbanker.com",
    titleSolution: "Investment and Trust",
  },
  {
    urlSolution: BUSINESS_FOREX_SERVICE,
    emailSolution: "SEDEX-RetailSalesDivision@eastwestbanker.com",
    titleSolution: "Forex Services",
  },
  {
    urlSolution: BUSINESS_INSURANCE,
    emailSolution: "#EWIBI@eastwestbanker.com",
    titleSolution: "Insurance",
  },
];

export const AUTO_LOAN_EMAIL =
  "#LoansCluster-SecuredLendingGroup-SalesSupport@eastwestbanker.com";

export const TYPE_OF_BUSINESS_DROPDOWN_FOR_PROFILING =
  arrangeArrayOfStringAlphabetically(
    NATURE_OF_BUSINESS.map((item) => ({ value: item, label: item })),
    "label"
  );
